export const isValidGoogleSlidesURL = (rawUrl: string) => {
  try {
    const url = new URL(rawUrl);
    return (
      url.origin === 'https://docs.google.com' &&
      /\/presentation\/d(\/e)?/i.test(url.pathname)
    );
  } catch {
    return false;
  }
};

export const buildGoogleSlidesURL = (
  rawUrl: string,
  startingSlideNumber: number,
) => {
  if (!rawUrl) return '';

  return `${rawUrl.replace(/\/pub/i, '/embed')}${
    !/&rm=minimal/i.test(rawUrl) ? '&rm=minimal' : ''
  }${!/&slide=/i.test(rawUrl) ? '&slide=' + startingSlideNumber : ''}`;
};
